import React, { useEffect, useState } from 'react'
import Search from '../Search'
import { config } from 'config/config'
import { onClientSide } from '@/utils/utils'

const { env, novaRB } = config.abTest

function setCookie(name, value) {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 10);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/`;
}

function shouldRedirectNewRB() {
    if (!onClientSide()) {
        return false
    }

  const testKey = `${env}_${novaRB.keys}`

  return localStorage.getItem(testKey) === 'B'
}

function writeNewRBCookie() {
    if (!onClientSide()) {
        return false
    }

  setCookie('novarb', 'novarb', 10000)
}

function reload() {
    if (!onClientSide()) {
        return false
    }
    
    const wasReloaded = localStorage.getItem("wasReloaded");
    if (wasReloaded) {
        return false
    }

    localStorage.setItem("wasReloaded", true)

    location.reload();

    return true
}

export default function NovaRBRedirect({ ...props }) {
  const [shouldRedirect, setShouldRedirect] = useState(shouldRedirectNewRB())

  useEffect(() => {
    if (shouldRedirect) {
      writeNewRBCookie()

      setShouldRedirect(reload())
    }
  }, [shouldRedirect])

  if (shouldRedirect) {
    return (
      <div class="loader loader--show">
        <div class="loader__spin">&nbsp;</div>
      </div>
    )
  }

  return <Search {...props} />
}
